import { PipeWrenchIcon } from './PipeWrenchIcon';

/**
 * author: Google
 * id 5767EA8C-592F-4CEF-A01D-52F3CD0D111E
 * name pipe-wrench
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pipe-wrench.svg
 * tags
 * - Hardware / Tools 
 */
export const MonkeyWrenchIcon = PipeWrenchIcon;
export default MonkeyWrenchIcon